// Customizable Area Start
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { IBlock } from "../../../framework/src/IBlock";
import { runEngine } from "../../../framework/src/RunEngine";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { InviteFriendsStepType } from "./enums";
import { Contact, NormalizedContact } from "./InviteFriendsController.web";
import { ChangeEvent } from "react";

export const configJSON = require("./config");

export interface Props {
  contacts: NormalizedContact[];
  addContact: (contact: Contact) => void;
  setStep: (step: InviteFriendsStepType) => void;
  checkBulkContact: (contactId: number) => void;
  submitInvites: () => void;
  addContactModal?: () => void
  classes?: any;
}

interface S {
  filterValue: string;
  filteredContacts: NormalizedContact[];
  addContactBulk: boolean;
  isLoadingContacts: boolean;
}

interface SS {
  navigation: any;
  stepType: InviteFriendsStepType;
}

export default class BulkInviteFriendsController extends BlockComponent<
  Props,
  S,
  SS
> {
  constructor(props: Props) {
    super(props);
    this.subScribedMessages = [getName(MessageEnum.RestAPIResponceMessage)];

    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Show loader only if contacts is empty array (meaning data hasn't loaded yet)
    // If contacts already has data when modal opens, don't show loader
    const initialContacts = this.props.contacts || [];
    this.state = {
      addContactBulk: false,
      filterValue: "",
      filteredContacts: initialContacts,
      isLoadingContacts: initialContacts.length === 0,
    };
  }

  currentContacts = configJSON.currentContacts;
  search = configJSON.search;
  createContactDecription = configJSON.createContactDecription;
  selectedUsers = configJSON.selectedUsers;
  continueBulkInvite = configJSON.continueBulkInvite;
  contactList = configJSON.contactList;

  componentDidUpdate(prevProps: Props) {
    if (this.props.contacts !== prevProps.contacts) {
      // Once contacts prop changes (even if empty), it means API has responded, so hide loader
      const hasReceivedData = prevProps.contacts !== this.props.contacts;
      this.setState({
        filteredContacts: this.filterByValue(
          this.props.contacts,
          this.state.filterValue
        ),
        // Hide loader once we receive data (even if contacts array is empty)
        isLoadingContacts: false,
      });
    }
  }

  setStepBulkInvite = () => {
    this.setState({addContactBulk: false})
    this.props.setStep(InviteFriendsStepType.BULK_INVITE)
  }

  filterByValue = (contacts: NormalizedContact[], value: string = "") => {
    if (value.length) {
      return contacts.filter(
        (contact) =>
          contact.fullName.toLocaleLowerCase().includes(value) ||
          contact.email?.toLocaleLowerCase()?.includes(value)
      );
    }

    return contacts;
  };

  searchContact = (event: ChangeEvent<HTMLInputElement>) => {    
    let filteredContacts = this.props.contacts;
    const value = event.target.value.toLocaleLowerCase();
    this.setState({ filterValue: value });

    filteredContacts = this.filterByValue(filteredContacts, value);

    this.setState({
      filteredContacts,
    });
  };
}
// Customizable Area End
